// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"0cec3af9","644":"e60ee3b0"}[chunkId] + ".chunk.js";
};